import React, { createContext, useContext, useState } from "react";
import GenericPopup from "@/components/GenericPopup";

const PopupContext = createContext();

export function PopupProvider({ children }) {
    const [popupState, setPopupState] = useState({ isOpen: false });

    // props: { title, message, buttonText, onButtonClick, linkText, onLinkClick }
    const showPopup = (props) => {
        setPopupState({ ...props, isOpen: true });
    };

    const closePopup = () => {
        setPopupState((prev) => ({ ...prev, isOpen: false }));
    };

    return (
        <PopupContext.Provider value={{ showPopup, closePopup }}>
            {children}
            <GenericPopup {...popupState} onClose={closePopup} />
        </PopupContext.Provider>
    );
}

export function usePopup() {
    return useContext(PopupContext);
}
